/** Human-friendly event labels for nav (internal id stays in URLs/API). */

export function eventNavLabel(event) {
  if (!event || typeof event !== "object") return "Event";
  const handle = String(event.handle || "").trim();
  const title = String(event.title || "").trim();
  return handle || title || "Event";
}

export function eventInternalId(event) {
  return String(event?.id || "").trim();
}
